import $ from 'jquery';
//import * as CONST from '../utils/constants';
//import Util from '../utils/ui';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
//import 'slick-carousel';

class Common {
    constructor() {

    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('.form-container').validate();

        // phone mask
        //$('.js-phone-input').mask('(000) 000-0000');

        $('#contact-form').on('submit', e => { this.validateForm(e); });

        $('[data-hasdepending="true"]').on('change', e => { this.toggleDependingForm(e); });

        //$('.slick-slider').slick({
        //    slidesToShow: 1,
        //    slidesToScroll: 1,
        //    arrows: true,
        //    fade: true,
        //});
    }

    conditionallyRequiredToggle(parentValue, item) {
        $(item).each((index, formGroup) => {
            let $formInput = $(formGroup).find('.conditionally-required');
            $formInput.attr('required', parentValue);

            if (!parentValue) {
                $formInput.removeClass('input-validation-error');

                let $errorContainer = $formInput.siblings('span.error');
                $errorContainer.removeClass('field-validation-error').addClass('field-validation-valid');
            }
        });
    }

    toggleDependingForm(e) {
        let value = $(e.currentTarget).val();
        let name = $(e.currentTarget).attr('name');

        let questions = $(`[data-dependingquestion="${name}"]`);

        $(questions).each((index, item) => {
            if (Array.isArray(value)) {
                if (value.includes($(item).data('dependinganswer'))) {
                    $(item).show();
                    this.conditionallyRequiredToggle(true, $(item));
                }
                else {
                    $(item).hide();
                    this.conditionallyRequiredToggle(false, $(item));
                }
            }
            else {
                if (value.toLowerCase().indexOf($(item).data('dependinganswer').toLowerCase()) !== -1) {
                    $(item).show();
                    this.conditionallyRequiredToggle(true, $(item));
                }
                else {
                    $(item).hide();
                    this.conditionallyRequiredToggle(false, $(item));
                }
            }

            //handle depending answer being multiple options
            let dependingAnswer = $(item).data('dependinganswer');
            if (dependingAnswer.includes(',')) {
                const answers = dependingAnswer.split(',');
                if ($.inArray(value, answers) !== -1) {
                    $(item).show();
                    this.conditionallyRequiredToggle(true, $(item));
                }
                else {
                    $(item).hide();
                    this.conditionallyRequiredToggle(false, $(item));
                }
            }
        });
    }

    validateForm(e) {
        if ($('#recaptcha_contact')[0] && grecaptcha.getResponse().length === 0) {
            e.preventDefault();
            $('#recaptcha_contact').next().show();
            return false;
        }
        else {
            if ($('#recaptcha_contact')[0]) {
                $('#recaptcha_contact').next().hide();
            }
            return true;
        }
    }
}

export default Common;